module.exports = __webpack_public_path__ + "2f326f45a930d14304379c61e37570f3.png";